import { Component, Input } from '@angular/core';
import { SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'bepatient-onboarding-subtitle',
  templateUrl: './onboarding-subtitle.component.html',
  styleUrls: ['./onboarding-subtitle.component.scss'],
  standalone: false
})
export class OnboardingSubtitleComponent {
  @Input() title: string;
  @Input() color: string | SafeStyle;
}
